import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { 
  createCustomer, 
  editCustomer, 
  fetchCustomerDetail, 
  resetCurrentCustomer, 
  fetchCustomers, 
  fetchFJAgents, 
  updateFJAgents, 
  deleteFJAgents, 
  fetchPT, 
  updatePT,
  generateCustomerNoWithBusinessType, 
  generateRefNoWithBusinessType, 
  getAutoCustomerNumber,
  fetchInviteCustomer,
  fetchCustomerBuyerList,
 } from '../../actions/customers_actions';
import { setDefaultOfForm, changeFieldArrayOfForm } from '../../actions/purchaseOrders_actions';
import {
  fetchDefaultBuyers,
  setValue
} from '../../actions/products_actions';
import { fetchBaseUsers } from '../../actions/settings_actions';
import CustomerForm from '../../components/Customers/customerForm';
import {
  ROOT_URL, ROOT_API_URL, isESC, isVAK, isSV, isLMH, isBRO, isSDR, isCRW, isEKC, isSC
} from '../../actions/root_url';


const validate = (values) => {
  const errors = {};
  if (!values.Name && !isSV) {
    errors.Name = 'Required';
  }
  if (!values.CustomerNum && !isSV && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isVAK) {
    errors.CustomerNum = 'Required';
  }
  // if (!values.CreditLimit) {
  //     errors.CreditLimit = 'Required'
  // }
  if (!values.PriceLevel && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isSV) {
    errors.PriceLevel = 'Required';
  }
  if (values.IsWholesale === null && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isSV) {
    errors.IsWholesale = 'Required';
  }
  if (values.IsActive === null && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isSV) {
    errors.IsActive = 'Required';
  }
  if (!isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isESC && !isSV && (values.PaymentTerm_id === null || typeof (values.PaymentTerm_id) === 'undefined')) {
    errors.PaymentTerm_id = 'Required';
  }
  if (isESC && (!values.Billing || !values.Billing.AddressName)) {
    !errors.Billing && (errors.Billing = {})
    errors.Billing.AddressName = 'Required';
  }
  if (isESC && (!values.Mailing || !values.Mailing.AddressName)) {
    !errors.Mailing && (errors.Mailing = {})
    errors.Mailing.AddressName = 'Required';
  }
  const shippingList = values.Shipping
  if (isESC && shippingList && shippingList.length) {
    shippingList.forEach((item, index) => {
      if (item.AddressName) {
        return
      }
      if (!errors.Shipping) {
        errors.Shipping = []
      }
      if (!errors.Shipping[index]) {
        errors.Shipping[index] = {}
      }
      errors.Shipping[index].AddressName = 'Required'
    })
  }

  return errors;
};


const customerForm = reduxForm({
  form: 'customerForm',
  validate,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
})(CustomerForm);

const selector = formValueSelector('customerForm');

function mapStateToProps(state) {
  const paymentTerm_id = selector(state, 'PaymentTerm_id');
  const isActive = selector(state, 'IsActive');
  const IsShowPrice = selector(state, 'IsShowPrice');
  const billing = selector(state, 'Billing');
  const mailing = selector(state, 'Mailing');
  const shipping = selector(state, 'Shipping');
  const notation = selector(state, 'Notation');
  const Name = selector(state, 'Name');
  const ContactName = selector(state, 'ContactName');

  const Sales_User_id = selector(state, 'Sales_User_id');
  const Sales_User_id2 = selector(state, 'Sales_User_id2');
  const Commission = selector(state, 'Commission');
  const Commission2 = selector(state, 'Commission2');
  const Company_id = selector(state, 'Company_id');
  let companies = state.header.companies;
  
  if (isVAK) {
    const userPermissioins = localStorage.getItem('userPermissions');
    companies = state.header.companies.filter(({ permission_name }) => userPermissioins.includes(permission_name))
  }
  let companySelection = companies.map(({ Name, id }) => ({
    label: Name,
    value: id,
    isChecked: false,
  }));
  
  return {
    companySelection,
    paymentTerm_id,
    isActive,
    IsShowPrice,
    Name,
    ContactName,
    billing,
    mailing,
    shipping,
    notation,
    Sales_User_id,
    Sales_User_id2,
    Commission,
    Commission2,
    Company_id,
    currentCustomer: state.customers.currentCustomer,
    currentCustomerDetail: state.customers.currentCustomerDetail,
    detailIsLoading: state.customers.detailIsLoading,
    detailError: state.customers.detailError,
    initialValues: state.customers.currentCustomerDetail,
    isCreating: state.customers.isCreating,
    createError: state.customers.createError,
    created: state.customers.created,
    isEditing: state.vendors.isEditing,
    editError: state.vendors.editError,
    edited: state.vendors.edited,

    defaultBuyers: state.products.defaultBuyers,
    defaultBuyersIsLoading: state.products.defaultBuyersIsLoading,
    defaultBuyersError: state.products.defaultBuyersError,

    paymentTerms: state.paymentTerms.all,
    paymentTermsIsLoading: state.paymentTerms.isLoading,
    paymentTermsError: state.paymentTerms.error,
    userPermissions: state.auth.userPermissions,

    customers: state.customers.all,
    users: state.settings.all,
    selectedCompany: state.header.selectedCompany
  };
}


export default connect(mapStateToProps, {
  fetchPaymentTerms,
  createCustomer,
  editCustomer,
  fetchCustomerDetail,
  setDefaultOfForm,
  changeFieldArrayOfForm,
  fetchDefaultBuyers,
  resetCurrentCustomer,
  fetchCustomers,
  fetchFJAgents,
  updateFJAgents,
  deleteFJAgents,
  fetchPT,
  updatePT,
  fetchBaseUsers,
  setValue,
  generateCustomerNoWithBusinessType,
  generateRefNoWithBusinessType,
  getAutoCustomerNumber,
  fetchInviteCustomer,
  fetchCustomerBuyerList,
})(customerForm);


// fields: ['Customer_id', 'CustomerNum', 'RefNum', 'Name', 'Description', 'Bill_CustomerContact_id',
//     'Mail_CustomerContact_id', 'Ship_CustomerContact_id', 'Bill_CustomerAddress_id', 'Mail_CustomerAddress_id',
//     'Ship_CustomerAddress_id', 'IsWholesale', 'Sales_User_id', 'PaymentTerm_id', 'CreditLimit', 'CreditStatus', 'OrderType',
//     'PriceLevel', 'IsActive', 'DeliverPlan_id', 'IsPrtReminder', 'IsPrtGeneralInfor', 'Addresses[].Name', 'Addresses[].State',
//     'Addresses[].City', 'Addresses[].Tax_rate', 'Wholesale_ResaleNo']



// WEBPACK FOOTER //
// ./master/jsx/containers/Customers/customerForm.jsx